import { ImmutableStore } from 'fluxible-immutable-utils';
import Actions from '../constants/Actions';

const defaultState = {
  helpVideo: null,
  loading: false,
  error: null
};

class LearnMoreStore extends ImmutableStore {

  static storeName = 'LearnMoreStore';

  static handlers = {
    [Actions.QUERY_HELP_VIDEO]: 'setToLoading',
    [Actions.HELP_VIDEO_QUERIED]: 'setHelpVideo',
    [Actions.HELP_VIDEO_QUERY_FAILED]: 'setToError'
  };

  constructor(dispatcher) {
    super(dispatcher);
    this.setState(defaultState);
  }

  getHelpVideo() {
    return this.get('helpVideo');
  }

  isLoading() {
    return this.get('loading');
  }

  hasError() {
    return this.get('error');
  }

  setToLoading() {
    this.setState({
      helpVideo: null,
      loading: true,
      error: null
    });
  }

  setHelpVideo(helpVideo) {
    this.setState({
      helpVideo: helpVideo,
      loading: false,
      error: null
    });
  }

  setToError() {
    this.setState({
      helpVideo: null,
      loading: false,
      error: 'Failed to load video'
    });
  }

}

export default LearnMoreStore;



// WEBPACK FOOTER //
// ./src/stores/LearnMoreStore.js